
(function($) {

    /**
     * SignaturePad wrapper for jQuery
     *
     * @see https://github.com/szimek/signature_pad
     */
    $.fn.signaturePad = function(options) {
        var args = Array.prototype.slice.call(arguments, 1);
        var result = null;

        var self = $.each(this, function() {
            var element = $(this),
                input = element.parent().children('input'),
                canvas = element[0],
                signature = element.data('signaturePad');

            if (!signature) {
                signature = new SignaturePad(this, options);
                element.data('signaturePad', signature);

                canvas.width = 600;
                canvas.height = 300;

                // Clear button
                element.parent().find('[data-action=clear]').on('click', function() {
                    signature.clear()
                });

                // Initial value
                var value = input.val();
                if (value) {
                    signature.fromDataURL(value)
                }

                // Write value on submit
                var modal = element.closest('.modal');
                if (modal.length) {
                    modal.on('form-submit.modal', function(event, form, options) {
                        options.data = {} || options.data;

                        options.data[input.attr('name')] = signature.isEmpty() ? '' : signature.toDataURL();
                    })
                } else {
                    element.closest('form').on('submit', function() {
                        input.val(signature.isEmpty() ? '' : signature.toDataURL())
                    })
                }
            } else {
                if (typeof options == 'string') {
                    result = signature[options].apply(signature, args);
                }
            }
        });

        return (null !== result) ? result : self;
    }

})(jQuery);


// WEBPACK FOOTER //
// ./js/form/signature.js